const REACT_APP_TITLE = process.env.REACT_APP_TITLE;
const REACT_APP_DESCRIPTION = process.env.REACT_APP_DESCRIPTION;
const REACT_APP_VERSION = process.env.REACT_APP_VERSION;

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
const REACT_APP_API_PORT = process.env.REACT_APP_API_PORT;
const REACT_ENVIRONMENT = process.env.REACT_ENVIRONMENT;

const REACT_APP_CAPTCHA_KEY = process.env.REACT_APP_CAPTCHA_KEY;
const REACT_APP_KEY = process.env.REACT_APP_KEY;
const REACT_APP_IV = process.env.REACT_APP_IV;

const REACT_APP_SPONSOR = process.env.REACT_APP_SPONSOR;

const REACT_APP_GEOMOK = process.env.REACT_APP_GEOMOK;

//angel.lizcano
//URLS DE NEGOCIO LOGIN
const REACT_APP_ENDPOINT_LOGIN = process.env.REACT_APP_ENDPOINT_LOGIN;
const REACT_APP_API_ENDPOINT_LOGIN = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_LOGIN}`;

//sebastian.molina
//URLS DE NEGOCIO LOGIN
const REACT_APP_ENDPOINT_SECTORES = process.env.REACT_APP_ENDPOINT_SECTORES;
const REACT_APP_API_ENDPOINT_SECTORES = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_SECTORES}`;



//sthewar.rojano
//URLS OF BUSINESS PREREGISTER
const REACT_APP_ENDPOINT_PREREGISTER = process.env.REACT_APP_ENDPOINT_PREREGISTER;
const REACT_APP_API_ENDPOINT_PREREGISTER= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_PREREGISTER}`;

//sthewar.rojano
//URLS OF BUSINESS REGISTER
const REACT_APP_ENDPOINT_REGISTER = process.env.REACT_APP_ENDPOINT_REGISTER;
const REACT_APP_API_ENDPOINT_REGISTER= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_REGISTER}`;

//sthewar.rojano
//URLS OF BUSINESS LOGIN WITH TOKEN NEXT REGISTER
const REACT_APP_ENDPOINT_LOGINWITHTOKEN = process.env.REACT_APP_ENDPOINT_LOGINWITHTOKEN;
const REACT_APP_API_ENDPOINT_LOGINWITHTOKEN= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_LOGINWITHTOKEN}`;

//sthewar.rojano
//URLS OF BUSINESS LOGIN WITH TOKEN NEXT REGISTER
const REACT_APP_ENDPOINT_EMAILSEND = process.env.REACT_APP_ENDPOINT_EMAILSEND;
const REACT_APP_API_ENDPOINT_EMAILSEND= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_EMAILSEND}`;

//sthewar.rojano
//URLS OF BUSINESS LOGIN WITH TOKEN NEXT REGISTER
const REACT_APP_ENDPOINT_LOGINGETSESSION = process.env.REACT_APP_ENDPOINT_LOGINGETSESSION;
const REACT_APP_API_ENDPOINT_LOGINGETSESSION= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_LOGINGETSESSION}`;

//sthewar.rojano
//URLS OF BUSINESS DOCUMENT TYPE
const REACT_APP_ENDPOINT_DOCUMENT_TYPE = process.env.REACT_APP_ENDPOINT_DOCUMENT_TYPE;
const REACT_APP_API_ENDPOINT_DOCUMENT_TYPE= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_DOCUMENT_TYPE}`;

//andres.marin
//URLS OF BUSINESS SCHEDULING
const REACT_APP_ENDPOINT_SCHEDULING_TYPES = process.env.REACT_APP_ENDPOINT_SCHEDULING_TYPES;
const REACT_APP_API_ENDPOINT_SCHEDULING_TYPES= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_SCHEDULING_TYPES}`;

const REACT_APP_ENDPOINT_SCHEDULING_GET = process.env.REACT_APP_ENDPOINT_SCHEDULING_GET;
const REACT_APP_API_ENDPOINT_SCHEDULING_GET= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_SCHEDULING_GET}`;

const REACT_APP_ENDPOINT_SCHEDULING_GET_SCHEDULE = process.env.REACT_APP_ENDPOINT_SCHEDULING_GET_SCHEDULE;
const REACT_APP_API_ENDPOINT_SCHEDULING_GET_SCHEDULE= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_SCHEDULING_GET_SCHEDULE}`;

const REACT_APP_ENDPOINT_SCHEDULING_ADD = process.env.REACT_APP_ENDPOINT_SCHEDULING_ADD;
const REACT_APP_API_ENDPOINT_SCHEDULING_ADD= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_SCHEDULING_ADD}`;

const REACT_APP_ENDPOINT_SCHEDULING_UPDATE = process.env.REACT_APP_ENDPOINT_SCHEDULING_UPDATE;
const REACT_APP_API_ENDPOINT_SCHEDULING_UPDATE = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_SCHEDULING_UPDATE}`;

const REACT_APP_ENDPOINT_SCHEDULING_DELETE = process.env.REACT_APP_ENDPOINT_SCHEDULING_DELETE;
const REACT_APP_API_ENDPOINT_SCHEDULING_DELETE= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_SCHEDULING_DELETE}`;

const REACT_APP_ENDPOINT_SCHEDULING_MESSAGE = process.env.REACT_APP_ENDPOINT_SCHEDULING_MESSAGE;
const REACT_APP_API_ENDPOINT_SCHEDULING_MESSAGE= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_SCHEDULING_MESSAGE}`;

//sthewar.rojano
//URLS OF BUSINESS LINK OF LOGIN TO TRIBUTI
const REACT_APP_ENDPOINT_GET_LINK_TRIBUTI = process.env.REACT_APP_ENDPOINT_GET_LINK_TRIBUTI;
const REACT_APP_API_ENDPOINT_GET_LINK_TRIBUTI= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_GET_LINK_TRIBUTI}`;

//sthewar.rojano
//URLS OF BUSINESS LINK OF LOGIN TO COURSERA
const REACT_APP_ENDPOINT_GET_LINK_COURSERA = process.env.REACT_APP_ENDPOINT_GET_LINK_COURSERA;
const REACT_APP_API_ENDPOINT_GET_LINK_COURSERA= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_GET_LINK_COURSERA}`;

//sthewar.rojano
//URLS OF BUSINESS GENERAL INFO
const REACT_APP_ENDPOINT_GET_GENERAL_INFO = process.env.REACT_APP_ENDPOINT_GET_GENERAL_INFO;
const REACT_APP_API_ENDPOINT_GET_GENERAL_INFO = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_GET_GENERAL_INFO}`;

const REACT_APP_ENDPOINT_UPDATE_PERSONAL_INFO = process.env.REACT_APP_ENDPOINT_UPDATE_PERSONAL_INFO;
const REACT_APP_API_ENDPOINT_UPDATE_PERSONAL_INFO = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_UPDATE_PERSONAL_INFO}`;

const REACT_APP_ENDPOINT_UPDATE_PASSWORD = process.env.REACT_APP_ENDPOINT_UPDATE_PASSWORD;
const REACT_APP_API_ENDPOINT_UPDATE_PASSWORD = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_UPDATE_PASSWORD}`;

//sebastian.molina
//URLS OF BUSINESS 
const REACT_APP_ENDPOINT_GET_AGENDAS_USUARIO = process.env.REACT_APP_ENDPOINT_GET_AGENDAS_USUARIO;
const REACT_APP_API_ENDPOINT_GET_AGENDAS_USUARIO = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_GET_AGENDAS_USUARIO}`;

const REACT_APP_ENDPOINT_GET_AGENDA = process.env.REACT_APP_ENDPOINT_GET_AGENDA;
const REACT_APP_API_ENDPOINT_GET_AGENDA = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_GET_AGENDA}`;

const REACT_APP_ENDPOINT_DELETE_AGENDA = process.env.REACT_APP_ENDPOINT_DELETE_AGENDA;
const REACT_APP_API_ENDPOINT_DELETE_AGENDA = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_DELETE_AGENDA}`;

const REACT_APP_ENDPOINT_UPDATE_AGENDA = process.env.REACT_APP_ENDPOINT_UPDATE_AGENDA;
const REACT_APP_API_ENDPOINT_UPDATE_AGENDA = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_UPDATE_AGENDA}`;

//angel.lizcano
//URLS DE NEGOCIO EMITIONS
//TODO: <angel.lizcano> : Optimizar, condicionar el uso del puerto, si aplica o no
const ENDPOINT_EMITIONS = process.env.ENDPOINT_EMITIONS;
const API_ENDPOINT_EMITIONS = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_LOGIN}`;

//henry.nuncira
//URLS OF BUSINESS LINK OF NETWORKING
const REACT_APP_ENDPOINT_GET_LINK_NETWORKING_LISCITY = process.env.REACT_APP_ENDPOINT_GET_LINK_NETWORKING_LISCITY;
const REACT_APP_API_ENDPOINT_GET_LINK_NETWORKING_LISCITY= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_GET_LINK_NETWORKING_LISCITY}`;

const REACT_APP_ENDPOINT_GET_LINK_NETWORKING_LISTEVENTS = process.env.REACT_APP_ENDPOINT_GET_LINK_NETWORKING_LISTEVENTS;
const REACT_APP_API_ENDPOINT_GET_LINK_NETWORKING_LISTEVENTS= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_GET_LINK_NETWORKING_LISTEVENTS}`;

const REACT_APP_ENDPOINT_GET_LINK_NETWORKING_LISTINSCRIPTIONEVENTS = process.env.REACT_APP_ENDPOINT_GET_LINK_NETWORKING_LISTINSCRIPTIONEVENTS;
const REACT_APP_API_ENDPOINT_GET_LINK_NETWORKING_LISTINSCRIPTIONEVENTS= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_GET_LINK_NETWORKING_LISTINSCRIPTIONEVENTS}`;

const REACT_APP_ENDPOINT_GET_LINK_NETWORKING_LISTDISABLEINSCRIPTIONEVENTS = process.env.REACT_APP_ENDPOINT_GET_LINK_NETWORKING_LISTDISABLEINSCRIPTIONEVENTS;
const REACT_APP_API_ENDPOINT_GET_LINK_NETWORKING_LISTDISABLEINSCRIPTIONEVENTS= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_GET_LINK_NETWORKING_LISTDISABLEINSCRIPTIONEVENTS}`;

const REACT_APP_ENDPOINT_GET_LINK_NETWORKING_LISTSECTOR = process.env.REACT_APP_ENDPOINT_GET_LINK_NETWORKING_LISTSECTOR;
const REACT_APP_API_ENDPOINT_GET_LINK_NETWORKING_LISTSECTOR= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_GET_LINK_NETWORKING_LISTSECTOR}`;

const REACT_APP_ENDPOINT_GET_LINK_NETWORKING_LISTNETWORKING = process.env.REACT_APP_ENDPOINT_GET_LINK_NETWORKING_LISTNETWORKING;
const REACT_APP_API_ENDPOINT_GET_LINK_NETWORKING_LISTNETWORKING= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_GET_LINK_NETWORKING_LISTNETWORKING}`;

const REACT_APP_ENDPOINT_GET_INFO_COMMUNITY = process.env.REACT_APP_ENDPOINT_GET_INFO_COMMUNITY;
const REACT_APP_API_GET_INFO_COMMUNITY= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_GET_INFO_COMMUNITY}`;

const REACT_APP_ENDPOINT_UPDATE_INFO_COMMUNITY = process.env.REACT_APP_ENDPOINT_UPDATE_INFO_COMMUNITY;
const REACT_APP_API_UPDATE_INFO_COMMUNITY= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_UPDATE_INFO_COMMUNITY}`;

const REACT_APP_ENDPOINT_GET_LINK_NETWORKING_SHOWEVENTSINSCRIPTION = process.env.REACT_APP_ENDPOINT_GET_LINK_NETWORKING_SHOWEVENTSINSCRIPTION;
const REACT_APP_API_ENDPOINT_GET_LINK_NETWORKING_SHOWEVENTSINSCRIPTION= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_GET_LINK_NETWORKING_SHOWEVENTSINSCRIPTION}`;

const REACT_APP_ENDPOINT_GET_LINK_NETWORKING_ADDVENTSINSCRIPTION = process.env.REACT_APP_ENDPOINT_GET_LINK_NETWORKING_ADDVENTSINSCRIPTION;
const REACT_APP_API_ENDPOINT_GET_LINK_NETWORKING_ADDVENTSINSCRIPTION= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_GET_LINK_NETWORKING_ADDVENTSINSCRIPTION}`;
const REACT_APP_ENDPOINT_SET_NETWORKING_LOGIN = process.env.REACT_APP_ENDPOINT_NETWORKING_USABILITY;
const REACT_APP_API_ENDPOINT_SET_NETWORKING_LOGIN= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_SET_NETWORKING_LOGIN}`;

//URLS DE NEGOCIO COMPARA ADDLOGS
const REACT_APP_ENDPOINT_LOGUSER_INSERTA = process.env.REACT_APP_ENDPOINT_LOGUSER_INSERTA;
const REACT_APP_API_ENDPOINT_LOGUSER_INSERTA = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_LOGUSER_INSERTA}`;

const REACT_APP_ENDPOINT_LOGUSER_INSERTA_LISTA = process.env.REACT_APP_ENDPOINT_LOGUSER_INSERTA_LISTA;
const REACT_APP_API_ENDPOINT_LOGUSER_INSERTA_LISTA = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_LOGUSER_INSERTA_LISTA}`;

//URLS OF PARAMETER
const REACT_APP_ENDPOINT_GET_LOGIN_PARAMETRO = process.env.REACT_APP_ENDPOINT_GET_LOGIN_PARAMETRO;
const REACT_APP_API_ENDPOINT_GET_LOGIN_PARAMETROA = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_GET_LOGIN_PARAMETRO}`;

//URLS OF TOKEN REFRESH
const REACT_APP_ENDPOINT_GET_TOKEN_REFRESH = process.env.REACT_APP_ENDPOINT_GET_TOKEN_REFRESH;
const REACT_APP_API_ENDPOINT_GET_TOKEN_REFRESH = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_GET_TOKEN_REFRESH}`;

//URLS OF LOGOUT
const REACT_APP_ENDPOINT_LOGOUT = process.env.REACT_APP_ENDPOINT_LOGOUT;
const REACT_APP_API_ENDPOINT_LOGOUT = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_LOGOUT}`;

//andres.marin
//URLS DE NEGOCIO CURRICULUM
const REACT_APP_ENDPOINT_HV_DELETE_EDUCATION = process.env.REACT_APP_ENDPOINT_HV_DELETE_EDUCATION;
const REACT_APP_API_ENDPOINT_HV_DELETE_EDUCATION = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_HV_DELETE_EDUCATION}`;

const REACT_APP_ENDPOINT_HV_DELETE_WORKINGINFORMATION = process.env.REACT_APP_ENDPOINT_HV_DELETE_WORKINGINFORMATION;
const REACT_APP_API_ENDPOINT_HV_DELETE_WORKINGINFORMATION = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_HV_DELETE_WORKINGINFORMATION}`;

const REACT_APP_ENDPOINT_HV_GET_PDF = process.env.REACT_APP_ENDPOINT_HV_GET_PDF;
const REACT_APP_API_ENDPOINT_HV_GET_PDF = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_HV_GET_PDF}`;

const REACT_APP_ENDPOINT_HV_GET_PHOTOCURRICULUM = process.env.REACT_APP_ENDPOINT_HV_GET_PHOTOCURRICULUM;
const REACT_APP_API_ENDPOINT_HV_GET_PHOTOCURRICULUM = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_HV_GET_PHOTOCURRICULUM}`;

const REACT_APP_ENDPOINT_HV_GET_TEMPLATES = process.env.REACT_APP_ENDPOINT_HV_GET_TEMPLATES;
const REACT_APP_API_ENDPOINT_HV_GET_TEMPLATES = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_HV_GET_TEMPLATES}`;

const REACT_APP_ENDPOINT_HV_CHECK_CURRICULUM = process.env.REACT_APP_ENDPOINT_HV_CHECK_CURRICULUM;
const REACT_APP_API_ENDPOINT_HV_CHECK_CURRICULUM = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_HV_CHECK_CURRICULUM}`;

const REACT_APP_ENDPOINT_HV_GET_USERPERSONALDATA = process.env.REACT_APP_ENDPOINT_HV_GET_USERPERSONALDATA;
const REACT_APP_API_ENDPOINT_HV_GET_USERPERSONALDATA = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_HV_GET_USERPERSONALDATA}`;

const REACT_APP_ENDPOINT_HV_ADD_EDUCATION = process.env.REACT_APP_ENDPOINT_HV_ADD_EDUCATION;
const REACT_APP_API_ENDPOINT_HV_ADD_EDUCATION = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_HV_ADD_EDUCATION}`;

const REACT_APP_ENDPOINT_HV_ADD_EDUCATIONCOMPLEMENTARY = process.env.REACT_APP_ENDPOINT_HV_ADD_EDUCATIONCOMPLEMENTARY;
const REACT_APP_API_ENDPOINT_HV_ADD_EDUCATIONCOMPLEMENTARY = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_HV_ADD_EDUCATIONCOMPLEMENTARY}`;

const REACT_APP_ENDPOINT_HV_ADD_WORKINGINFORMATION = process.env.REACT_APP_ENDPOINT_HV_ADD_WORKINGINFORMATION;
const REACT_APP_API_ENDPOINT_HV_ADD_WORKINGINFORMATION = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_HV_ADD_WORKINGINFORMATION}`;

const REACT_APP_ENDPOINT_HV_UPDATE_EDUCATION = process.env.REACT_APP_ENDPOINT_HV_UPDATE_EDUCATION;
const REACT_APP_API_ENDPOINT_HV_UPDATE_EDUCATION = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_HV_UPDATE_EDUCATION}`;

const REACT_APP_ENDPOINT_HV_UPDATE_EDUCATIONCOMPLEMENTARY = process.env.REACT_APP_ENDPOINT_HV_UPDATE_EDUCATIONCOMPLEMENTARY;
const REACT_APP_API_ENDPOINT_HV_UPDATE_EDUCATIONCOMPLEMENTARY = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_HV_UPDATE_EDUCATIONCOMPLEMENTARY}`;

const REACT_APP_ENDPOINT_HV_UPDATE_PERSONALDATA = process.env.REACT_APP_ENDPOINT_HV_UPDATE_PERSONALDATA;
const REACT_APP_API_ENDPOINT_HV_UPDATE_PERSONALDATA = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_HV_UPDATE_PERSONALDATA}`;

const REACT_APP_ENDPOINT_HV_UPDATE_PHOTOCURRICULUM = process.env.REACT_APP_ENDPOINT_HV_UPDATE_PHOTOCURRICULUM;
const REACT_APP_API_ENDPOINT_HV_UPDATE_PHOTOCURRICULUM = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_HV_UPDATE_PHOTOCURRICULUM}`;

const REACT_APP_ENDPOINT_HV_UPDATE_TEMPLATE = process.env.REACT_APP_ENDPOINT_HV_UPDATE_TEMPLATE;
const REACT_APP_API_ENDPOINT_HV_UPDATE_TEMPLATE = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_HV_UPDATE_TEMPLATE}`;

const REACT_APP_ENDPOINT_HV_UPDATE_WORKINGINFORMATION = process.env.REACT_APP_ENDPOINT_HV_UPDATE_WORKINGINFORMATION;
const REACT_APP_API_ENDPOINT_HV_UPDATE_WORKINGINFORMATION = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_HV_UPDATE_WORKINGINFORMATION}`;

const REACT_APP_ENDPOINT_HV_UPLOAD_PDF = process.env.REACT_APP_ENDPOINT_HV_UPLOAD_PDF;
const REACT_APP_API_ENDPOINT_HV_UPLOAD_PDF = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_HV_UPLOAD_PDF}`;

const REACT_APP_ENDPOINT_CITIESDEPARTMENT = process.env.REACT_APP_ENDPOINT_CITIESDEPARTMENT;
const REACT_APP_API_ENDPOINT_CITIESDEPARTMENT = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_CITIESDEPARTMENT}`;

const REACT_APP_ENDPOINT_DATADICTIONARY = process.env.REACT_APP_ENDPOINT_DATADICTIONARY;
const REACT_APP_API_ENDPOINT_DATADICTIONARY = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_DATADICTIONARY}`;

// ITT URLS
const REACT_APP_ENDPOINT_REGISTER_BRANDING = process.env.REACT_APP_ENDPOINT_REGISTER_BRANDING;
const REACT_APP_API_ENDPOINT_REGISTER_BRANDING = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_REGISTER_BRANDING}`;
const REACT_APP_ENDPOINT_RETRIEVE_BRANDING = process.env.REACT_APP_ENDPOINT_RETRIEVE_BRANDING;
const REACT_APP_API_ENDPOINT_RETRIEVE_BRANDING = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_RETRIEVE_BRANDING}`;
const REACT_APP_ENDPOINT_UPDATE_BRANDING = process.env.REACT_APP_ENDPOINT_UPDATE_BRANDING;
const REACT_APP_API_ENDPOINT_UPDATE_BRANDING = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_UPDATE_BRANDING}`;


//URLS OF PSICO TEST
const REACT_APP_ENDPOINT_PSICOTEST = process.env.REACT_APP_ENDPOINT_PSICOTEST;
const REACT_APP_API_ENDPOINT_PSICOTEST = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_PSICOTEST}`;
const REACT_APP_ENDPOINT_TYPETEST = process.env.REACT_APP_ENDPOINT_TYPETEST;
const REACT_APP_API_ENDPOINT_TYPETEST = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_TYPETEST}`;

const REACT_APP_ENDPOINT_PSICOTEST_USABILITY = process.env.REACT_APP_ENDPOINT_PSICOTEST_USABILITY;
const REACT_APP_API_ENDPOINT_PSICOTEST_USABILITY = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_PSICOTEST_USABILITY}`;


//Camilo Rodriguez
// URL JOBS OFFERS
const REACT_APP_ENDPOINT_DATAJOBSOFFERS = process.env.REACT_APP_ENDPOINT_DATAJOBSOFFERS;
const REACT_APP_API_ENDPOINT_DATAJOBSOFFERS = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_DATAJOBSOFFERS}`;

const REACT_APP_ENDPOINT_DATAJOBSOFFERS_SALARY = process.env.REACT_APP_ENDPOINT_DATAJOBSOFFERS_SALARY;
const REACT_APP_API_ENDPOINT_DATAJOBSOFFERS_SALARY = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_DATAJOBSOFFERS_SALARY}`;

const REACT_APP_ENDPOINT_DATAJOBSOFFERS_SECTORES = process.env.REACT_APP_ENDPOINT_DATAJOBSOFFERS_SECTORES;
const REACT_APP_API_ENDPOINT_DATAJOBSOFFERS_SECTORES = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_DATAJOBSOFFERS_SECTORES}`;

const REACT_APP_ENDPOINT_APLICATEOFFER = process.env.REACT_APP_ENDPOINT_APLICATEOFFER;
const REACT_APP_API_ENDPOINT_APLICATEOFFER = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_APLICATEOFFER}`;

const REACT_APP_ENDPOINT_RESOLUTIONS = process.env.REACT_APP_ENDPOINT_RESOLUTIONS
const REACT_APP_API_ENDPOINT_RESOLUTIONS = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_RESOLUTIONS}`;
const REACT_APP_ENDPOINT_ANDPSICO = process.env.REACT_APP_ENDPOINT_ANDPSICO
const REACT_APP_API_ENDPOINT_ANDPSICO = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_ANDPSICO}`;
const REACT_APP_ENDPOINT_REGISTERQUESTION = process.env.REACT_APP_ENDPOINT_REGISTERQUESTION
const REACT_APP_API_ENDPOINT_REGISTERQUESTION = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_REGISTERQUESTION}`;
const REACT_APP_ENDPOINT_REGISTERTEST = process.env.REACT_APP_ENDPOINT_REGISTERTEST
const REACT_APP_API_ENDPOINT_REGISTERTEST = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_REGISTERTEST}`;
const REACT_APP_ENDPOINT_SALARY_USABILITY = process.env.REACT_APP_ENDPOINT_SALARY_USABILITY;
const REACT_APP_API_ENDPOINT_SALARY_USABILITY = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_SALARY_USABILITY}`;


//Andres Marin
// URL VIDEOCALLS
const REACT_APP_VIDEOCALL_COLOR = process.env.REACT_APP_VIDEOCALL_COLOR;
const REACT_APP_VIDEOCALL_URL_CLIENT = process.env.REACT_APP_VIDEOCALL_URL_CLIENT;
const REACT_APP_VIDEOCALL_URL_VIDEOCALL = process.env.REACT_APP_VIDEOCALL_URL_VIDEOCALL;
const REACT_APP_VIDEOCALL_URLAPI_VIDEOCALL = process.env.REACT_APP_VIDEOCALL_URLAPI_VIDEOCALL;
const REACT_APP_VIDEOCALL_TOKEN_USER = process.env.REACT_APP_VIDEOCALL_TOKEN_USER;
const REACT_APP_VIDEOCALL_TOKEN_VIDEOCALL = process.env.REACT_APP_VIDEOCALL_TOKEN_VIDEOCALL;

//Andres Ayala
// URL videollamadas
const REACT_APP_ENDPOINT_POST_VIDEOCALL = process.env.REACT_APP_ENDPOINT_POST_VIDEOCALL;
const REACT_APP_API_ENDPOINT_POST_VIDEOCALL = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_POST_VIDEOCALL}`;
//RECOVERY
const REACT_APP_ENDPOINT_RECUPERAR = process.env.REACT_APP_ENDPOINT_RECUPERAR;
const REACT_APP_API_ENDPOINT_RECUPERAR = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_RECUPERAR}`;
const REACT_APP_ENDPOINT_RECUPERAR_COD = process.env.REACT_APP_ENDPOINT_RECUPERAR_COD;
const REACT_APP__API_ENDPOINT_RECUPERAR_COD = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_RECUPERAR_COD}`;
const REACT_APP_ENDPOINT_RECUPERAR_PASS = process.env.REACT_APP_ENDPOINT_RECUPERAR_PASS;
const REACT_APP_API_ENDPOINT_RECUPERAR_PASS = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_RECUPERAR_PASS}`;

//URL recuperar contraseña
const REACT_APP_ENDPOINT_RECOVERY_PASSWORD = process.env.REACT_APP_ENDPOINT_POST_UPDATE_SERVICIO;
const REACT_APP_API_ENDPOINT_RECOVERY_PASSWORD = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_RECOVERY_PASSWORD}`;

//sthewar.rojano
//URLS OF BUSINESS LOGIN WITH TOKEN NEXT REGISTER
const REACT_APP_ENDPOINT_UPDATESERVICIO = process.env.REACT_APP_ENDPOINT_POST_UPDATE_SERVICIO;
const REACT_APP_API_ENDPOINT_UPDATESERVICIO= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_UPDATESERVICIO}`;

//sthewar.rojano
//URLS OF BUSINESS REGISTER
const REACT_APP_ENDPOINT_REGISTER_UPDATE = process.env.REACT_APP_ENDPOINT_REGISTER_UPDATE;
const REACT_APP_API_ENDPOINT_REGISTER_UPDATE= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_REGISTER_UPDATE}`;

//Kevin Lopez
//URLS DE NEGOCIO LOGIN PARA CLUB ELITE
const REACT_APP_ENDPOINT_LOGIN_CLUB_ELITE = process.env.REACT_APP_ENDPOINT_LOGIN_CLUB_ELITE;
const REACT_APP_API_ENDPOINT_LOGIN_CLUB_ELITE = `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_LOGIN_CLUB_ELITE}`;

//kevin.lopez
//URLS OF BUSINESS LINK OF LOGIN TO INSTAFIT
const REACT_APP_ENDPOINT_GET_LINK_INSTAFIT = process.env.REACT_APP_ENDPOINT_GET_LINK_INSTAFIT;
const REACT_APP_API_ENDPOINT_GET_LINK_INSTAFIT= `${REACT_APP_API_URL}:${REACT_APP_API_PORT}/${REACT_APP_ENDPOINT_GET_LINK_INSTAFIT}`;

export {
        REACT_APP_IV,
        REACT_APP_KEY,
        REACT_APP_TITLE,
        REACT_ENVIRONMENT,
        REACT_APP_SPONSOR,
        REACT_APP_GEOMOK,
        ENDPOINT_EMITIONS,
        REACT_APP_VERSION,
        REACT_APP_API_URL,
        REACT_APP_API_PORT,
        API_ENDPOINT_EMITIONS,
        REACT_APP_DESCRIPTION,
        REACT_APP_CAPTCHA_KEY,
        REACT_APP_ENDPOINT_LOGIN,
        REACT_APP_API_ENDPOINT_LOGIN,
        REACT_APP_API_ENDPOINT_LOGOUT,
        REACT_APP_API_ENDPOINT_SECTORES,
        REACT_APP_API_ENDPOINT_REGISTER,
        REACT_APP_API_ENDPOINT_EMAILSEND,
        REACT_APP_API_ENDPOINT_PSICOTEST,
        REACT_APP_API_ENDPOINT_TYPETEST,
        REACT_APP_API_ENDPOINT_PSICOTEST_USABILITY,
        REACT_APP_API_ENDPOINT_GET_AGENDA,
        REACT_APP_ENDPOINT_LOGUSER_INSERTA,
        REACT_APP_ENDPOINT_LOGUSER_INSERTA_LISTA,
        REACT_APP_API_ENDPOINT_PREREGISTER,
        REACT_APP_API_ENDPOINT_UPDATE_AGENDA,
        REACT_APP_API_ENDPOINT_DELETE_AGENDA,
        REACT_APP_API_ENDPOINT_DOCUMENT_TYPE,
        REACT_APP_API_ENDPOINT_LOGINWITHTOKEN,
        REACT_APP_API_ENDPOINT_DATADICTIONARY,
        REACT_APP_API_ENDPOINT_SCHEDULING_TYPES,
        REACT_APP_API_ENDPOINT_SCHEDULING_GET,
        REACT_APP_API_ENDPOINT_SCHEDULING_GET_SCHEDULE,
        REACT_APP_API_ENDPOINT_SCHEDULING_ADD,
        REACT_APP_API_ENDPOINT_SCHEDULING_UPDATE,
        REACT_APP_API_ENDPOINT_SCHEDULING_DELETE,
        REACT_APP_API_ENDPOINT_SCHEDULING_MESSAGE,
        REACT_APP_API_ENDPOINT_RETRIEVE_BRANDING,
        REACT_APP_API_ENDPOINT_UPDATE_PASSWORD,
        REACT_APP_API_ENDPOINT_LOGINGETSESSION,
        REACT_APP_API_ENDPOINT_LOGUSER_INSERTA,
        REACT_APP_API_ENDPOINT_LOGUSER_INSERTA_LISTA,
        REACT_APP_API_ENDPOINT_UPDATE_BRANDING,
        REACT_APP_API_ENDPOINT_CITIESDEPARTMENT,
        REACT_APP_API_ENDPOINT_GET_LINK_TRIBUTI,
        REACT_APP_API_ENDPOINT_GET_GENERAL_INFO,
        REACT_APP_API_ENDPOINT_REGISTER_BRANDING,
        REACT_APP_API_ENDPOINT_GET_LINK_COURSERA,
        REACT_APP_API_ENDPOINT_GET_TOKEN_REFRESH,
        REACT_APP_API_ENDPOINT_GET_AGENDAS_USUARIO,
        REACT_APP_API_ENDPOINT_GET_LOGIN_PARAMETROA,
        REACT_APP_API_ENDPOINT_UPDATE_PERSONAL_INFO,
        REACT_APP_API_ENDPOINT_GET_LINK_NETWORKING_LISCITY,
        REACT_APP_API_ENDPOINT_GET_LINK_NETWORKING_LISTEVENTS,
        REACT_APP_API_ENDPOINT_GET_LINK_NETWORKING_LISTINSCRIPTIONEVENTS,
        REACT_APP_API_ENDPOINT_GET_LINK_NETWORKING_LISTDISABLEINSCRIPTIONEVENTS,
        REACT_APP_API_ENDPOINT_GET_LINK_NETWORKING_LISTNETWORKING,
        REACT_APP_API_ENDPOINT_GET_LINK_NETWORKING_LISTSECTOR,
        REACT_APP_API_ENDPOINT_GET_LINK_NETWORKING_ADDVENTSINSCRIPTION,
        REACT_APP_API_ENDPOINT_GET_LINK_NETWORKING_SHOWEVENTSINSCRIPTION,
        REACT_APP_API_ENDPOINT_SET_NETWORKING_LOGIN,
        REACT_APP_API_ENDPOINT_HV_DELETE_EDUCATION,
        REACT_APP_API_ENDPOINT_HV_DELETE_WORKINGINFORMATION,
        REACT_APP_API_ENDPOINT_HV_CHECK_CURRICULUM,
        REACT_APP_API_ENDPOINT_HV_GET_PDF,
        REACT_APP_API_ENDPOINT_HV_GET_PHOTOCURRICULUM,
        REACT_APP_API_ENDPOINT_HV_GET_TEMPLATES,
        REACT_APP_API_ENDPOINT_HV_GET_USERPERSONALDATA,
        REACT_APP_API_ENDPOINT_HV_ADD_EDUCATION,
        REACT_APP_API_ENDPOINT_HV_ADD_EDUCATIONCOMPLEMENTARY,
        REACT_APP_API_ENDPOINT_HV_ADD_WORKINGINFORMATION,
        REACT_APP_API_ENDPOINT_HV_UPDATE_EDUCATION,
        REACT_APP_API_ENDPOINT_HV_UPDATE_EDUCATIONCOMPLEMENTARY,
        REACT_APP_API_ENDPOINT_HV_UPDATE_PERSONALDATA,
        REACT_APP_API_ENDPOINT_HV_UPDATE_PHOTOCURRICULUM,
        REACT_APP_API_ENDPOINT_HV_UPDATE_TEMPLATE,
        REACT_APP_API_ENDPOINT_HV_UPDATE_WORKINGINFORMATION,
        REACT_APP_API_ENDPOINT_HV_UPLOAD_PDF,  
        REACT_APP_API_ENDPOINT_DATAJOBSOFFERS,
        REACT_APP_API_ENDPOINT_DATAJOBSOFFERS_SALARY,
        REACT_APP_API_ENDPOINT_DATAJOBSOFFERS_SECTORES,
        REACT_APP_API_ENDPOINT_APLICATEOFFER,
        REACT_APP_API_ENDPOINT_RESOLUTIONS,
        REACT_APP_API_ENDPOINT_ANDPSICO,
        REACT_APP_API_ENDPOINT_SALARY_USABILITY,
        REACT_APP_API_ENDPOINT_REGISTERQUESTION,
        REACT_APP_API_ENDPOINT_REGISTERTEST,
        REACT_APP_VIDEOCALL_COLOR,
        REACT_APP_VIDEOCALL_URL_CLIENT,
        REACT_APP_VIDEOCALL_URL_VIDEOCALL,
        REACT_APP_VIDEOCALL_URLAPI_VIDEOCALL,
        REACT_APP_VIDEOCALL_TOKEN_USER,
        REACT_APP_VIDEOCALL_TOKEN_VIDEOCALL,
        REACT_APP_ENDPOINT_POST_VIDEOCALL,
        REACT_APP_API_ENDPOINT_POST_VIDEOCALL,
        REACT_APP_API_ENDPOINT_RECUPERAR,
        REACT_APP__API_ENDPOINT_RECUPERAR_COD,
        REACT_APP_API_ENDPOINT_RECUPERAR_PASS,
        REACT_APP_ENDPOINT_RECOVERY_PASSWORD,
        REACT_APP_API_ENDPOINT_RECOVERY_PASSWORD,
        REACT_APP_API_ENDPOINT_UPDATESERVICIO,
        REACT_APP_API_ENDPOINT_REGISTER_UPDATE,
        REACT_APP_API_GET_INFO_COMMUNITY,
        REACT_APP_API_UPDATE_INFO_COMMUNITY,
        REACT_APP_ENDPOINT_LOGIN_CLUB_ELITE,
        REACT_APP_API_ENDPOINT_LOGIN_CLUB_ELITE,
        REACT_APP_API_ENDPOINT_GET_LINK_INSTAFIT
    }
